import LogBasicInfo from './LogBasicInfo';

export default LogBasicInfo;
